export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13617.be1d7f30.jpg";